import { Fragment } from "react";
import AppRouter from "../../AppRouter";

function App() {
  return (
    <Fragment>
      <AppRouter />
    </Fragment>
  );
}

export default App;
